import React from 'react';

import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import Chat from 'entities/Chat';
import ChatActions from 'chat/actions/ChatActions';
import SingleChatStreamView from 'chat/components/SingleChatStreamView';

type Props = {
  params: { streamUuid: string };
};

type State = {
  chat?: Chat;
};

export default class CoachingChatStreamContainer extends React.Component<Props, State> {
  state: State = {};

  async componentDidMount() {
    await this.loadChatIntoState();
  }

  async componentDidUpdate(prevProps: Props) {
    if (prevProps.params.streamUuid !== this.props.params.streamUuid) {
      this.setState({ chat: undefined });
      await this.loadChatIntoState();
    }
  }

  async loadChatIntoState() {
    const chat = await ChatActions.loadChat(this.props.params.streamUuid);
    this.setState({ chat });
  }

  render() {
    const { chat } = this.state;
    if (!chat) {
      return <CenteredLoadingIndicator />;
    }

    return <SingleChatStreamView chat={chat} streamUuid={this.props.params.streamUuid} />;
  }
}
